import { useState, useEffect } from 'react'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'
import TradeDetailContent from '../components/TradeDetailContent'
import { usePositionProjectLookup } from '../hooks/usePositionProjectLookup'
import { useSetupTradeLog } from '../hooks/useSetupTradeLog'
import SetupTradeDetailContent from '../components/SetupTradeDetailContent'

export default function TradeDetail() {
  const [search] = useSearchParams()
  const setupId = search.get('setup')
  return setupId ? <SetupDetail setupId={setupId} /> : <AccountTradeDetail />
}

function SetupDetail({ setupId }) {
  const { groups, nicknameMap, loading, error, reload } = useSetupTradeLog()
  const navigate = useNavigate()
  const group = groups.find(item => item.id === setupId)
  return <div className="space-y-4">
    <button className="text-xs underline" onClick={() => navigate('/positions/history')}>Back to Trade Log</button>
    <h1 className="text-xl font-bold">Setup review</h1>
    {loading ? <p role="status">Loading complete trade history…</p>
      : error ? <div role="alert">{error} <button onClick={reload}>Retry</button></div>
        : group ? <div className="bg-canvas border border-border rounded-xl"><SetupTradeDetailContent key={group.id} group={group} nicknameMap={nicknameMap} /></div>
          : <p>This setup has no confidently attributed trade records. Open Setup links to review in the Trade Log.</p>}
  </div>
}

function AccountTradeDetail() {
  const { tradeId } = useParams()
  const { user } = useAuth()
  const navigate = useNavigate()
  const { projectsByTradeId } = usePositionProjectLookup()
  const [nicknameMap, setNicknameMap] = useState({})

  useEffect(() => {
    if (!user) return
    async function load() {
      const { data: n } = await supabase
        .from('account_nicknames')
        .select('account_number, nickname')
        .eq('user_id', user.id)
      setNicknameMap(Object.fromEntries((n || []).map(r => [r.account_number, r.nickname])))
    }
    load()
  }, [user])

  return (
    <div className="space-y-4">
      {/* Back link */}
      <button
        onClick={() => navigate('/positions/history')}
        className="flex items-center gap-1.5 font-mono text-xs text-inkMuted hover:text-ink transition-colors"
      >
        <ArrowLeft size={14} />
        Back to Trade Log
      </button>

      {/* Trade detail card */}
      <div className="bg-canvas border border-border rounded-xl overflow-hidden min-h-[400px]">
        <TradeDetailContent tradeId={tradeId} nicknameMap={nicknameMap} projectId={projectsByTradeId[tradeId]} />
      </div>
    </div>
  )
}
